// extracted by mini-css-extract-plugin
export default {"wrapper":"status_wrapper__GQe-v","alertWrapper":"status_alertWrapper__dXxh1"};